<template>
  <div class="cloud-intercom-page">
    <div class="ci-body">
      <h1 class="ci-body__title">
        {{ $t('Intercom.CloudIntercom.Common.Welcome') }}
      </h1>
      <p
        v-if="communityName"
        class="ci-body__subtitle"
      >
        {{ $t('Intercom.CloudIntercom.Common.CommunityIntercom', { name: communityName }) }}
      </p>
      <img
        class="ci-body__illustration"
        src="@/assets/img/intercom/cloud-intercom-welcome.webp"
        alt=""
      >
      <div class="ci-body__notice">
        <span class="ci-body__notice-title">{{ $t('Intercom.CloudIntercom.WelcomePage.NoticeTitle') }}</span>
        <span class="ci-body__notice-description">{{ $t('Intercom.CloudIntercom.WelcomePage.NoticeDesc') }}</span>
        <span class="ci-body__notice-privacy">
          {{ $t('Intercom.CloudIntercom.WelcomePage.NoticePrivacy') }}
        </span>
      </div>
    </div>
    <div class="ci-footer">
      <button
        class="ci-btn ci-btn--primary"
        @click="$emit('start-verify')"
      >
        {{ $t('Intercom.CloudIntercom.WelcomePage.StartVerify') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
  props: {
    communityName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import './cloudIntercom';

.ci-footer {
  margin-top: 16px;
}
</style>
